import { render, staticRenderFns } from "./AddReservationParticipant.vue?vue&type=template&id=04b7c71a"
import script from "./AddReservationParticipant.vue?vue&type=script&lang=js"
export * from "./AddReservationParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports